const openFile = (fileName, fileObj) => {
  const blobObject = new Blob([fileObj.data], { type: fileObj.headers['content-type'] });
  const url = window.URL.createObjectURL(blobObject);
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', fileName);
  document.body.appendChild(link);
  link.click();
};

export {
  // eslint-disable-next-line import/prefer-default-export
  openFile,
};
